export default __webpack_public_path__ + "static/media/cp_geo_tj.839f273d.svg";